(function () {
  var marker = '20260722-us-row-2';
  var flag = 'url("//cdn.shopify.com/static/images/flags/us.svg?width=48")';
  var deliverySelectSelector = '[data-delivery-country-select], .zoalin-delivery select[name="country_code"], .zoalin-delivery__country-form select[name="country_code"]';
  var deliveryAsia = ['SG', 'MY', 'ID', 'TH', 'PH', 'VN', 'BN', 'KH', 'LA', 'MM', 'TL'];
  var deliveryMiddleEastUs = ['AE', 'SA', 'QA', 'KW', 'BH', 'OM', 'JO', 'US'];
  var deliveryStandard = ['GB', 'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'CA', 'AU', 'NZ', 'JP', 'KR', 'HK', 'MO', 'TW'];

  function css(el, styles) {
    if (!el) return;
    Object.keys(styles).forEach(function (key) {
      if (el.style.getPropertyValue(key) === styles[key] && el.style.getPropertyPriority(key) === 'important') return;
      el.style.setProperty(key, styles[key], 'important');
    });
  }

  function roots() {
    return Array.prototype.slice.call(document.querySelectorAll('.zoalin-localization, [data-zoalin-localization]'));
  }

  function rewriteContactLinks() {
    document.querySelectorAll('a[href]').forEach(function (link) {
      var href = link.getAttribute('href') || '';
      if (href === '/pages/contact' || href.indexOf('/pages/contact?') === 0) {
        link.setAttribute('href', '/pages/contact-us');
      }
    });
  }

  function injectDrawerCloseRightStyle() {
    var id = 'zoalin-menu-drawer-close-right-final-style';
    var existing = document.getElementById(id);
    var cssText = '@media (max-width: 749px), (pointer: coarse) and (orientation: landscape) and (max-height: 760px) {' +
      'html body #Details-menu-drawer-container[open] > .menu-drawer > button.menu-drawer__close-button,' +
      'html body #Details-menu-drawer-container.menu-open > .menu-drawer > button.menu-drawer__close-button,' +
      'html body.zoalin-menu-drawer-open #Details-menu-drawer-container > .menu-drawer > button.menu-drawer__close-button{' +
      'position:absolute!important;top:12px!important;right:14px!important;left:auto!important;inset-inline-start:auto!important;inset-inline-end:14px!important;transform:none!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;width:36px!important;min-width:36px!important;height:36px!important;min-height:36px!important;margin:0!important;padding:0!important;border:1px solid rgba(17,17,17,.14)!important;border-radius:6px!important;background:#fff!important;color:#111!important;box-shadow:0 1px 3px rgba(17,17,17,.04)!important;opacity:1!important;visibility:visible!important;pointer-events:auto!important;z-index:12!important;}' +
      'html body #Details-menu-drawer-container[open] > .menu-drawer > button.menu-drawer__close-button svg,' +
      'html body #Details-menu-drawer-container.menu-open > .menu-drawer > button.menu-drawer__close-button svg,' +
      'html body.zoalin-menu-drawer-open #Details-menu-drawer-container > .menu-drawer > button.menu-drawer__close-button svg{' +
      'display:block!important;width:15px!important;min-width:15px!important;height:15px!important;min-height:15px!important;}' +
      'html body #Details-menu-drawer-container[open] > .menu-drawer > .zoalin-menu-drawer-head,' +
      'html body #Details-menu-drawer-container.menu-open > .menu-drawer > .zoalin-menu-drawer-head,' +
      'html body.zoalin-menu-drawer-open #Details-menu-drawer-container > .menu-drawer > .zoalin-menu-drawer-head{' +
      'display:grid!important;grid-template-columns:minmax(0,1fr)!important;grid-template-rows:38px 38px!important;justify-items:start!important;align-items:center!important;gap:4px!important;min-height:98px!important;padding:11px 58px 10px 18px!important;box-sizing:border-box!important;}' +
      'html body #Details-menu-drawer-container[open] > .menu-drawer > .zoalin-menu-drawer-head .zoalin-menu-drawer-logo,' +
      'html body #Details-menu-drawer-container.menu-open > .menu-drawer > .zoalin-menu-drawer-head .zoalin-menu-drawer-logo,' +
      'html body.zoalin-menu-drawer-open #Details-menu-drawer-container > .menu-drawer > .zoalin-menu-drawer-head .zoalin-menu-drawer-logo{' +
      'grid-column:1!important;grid-row:1!important;justify-self:start!important;align-self:center!important;margin:0 0 0 4px!important;text-align:left!important;transform:none!important;}' +
      'html body #Details-menu-drawer-container[open] > .menu-drawer > .zoalin-menu-drawer-head .zoalin-menu-drawer-actions,' +
      'html body #Details-menu-drawer-container.menu-open > .menu-drawer > .zoalin-menu-drawer-head .zoalin-menu-drawer-actions,' +
      'html body.zoalin-menu-drawer-open #Details-menu-drawer-container > .menu-drawer > .zoalin-menu-drawer-head .zoalin-menu-drawer-actions{' +
      'grid-column:1!important;grid-row:2!important;justify-self:start!important;align-self:center!important;justify-content:flex-start!important;margin:0 0 0 4px!important;}' +
      '}' +
      '@media (max-width:359px){' +
      'html body #Details-menu-drawer-container[open] > .menu-drawer > .zoalin-menu-drawer-head,' +
      'html body #Details-menu-drawer-container.menu-open > .menu-drawer > .zoalin-menu-drawer-head,' +
      'html body.zoalin-menu-drawer-open #Details-menu-drawer-container > .menu-drawer > .zoalin-menu-drawer-head{' +
      'padding-left:16px!important;padding-right:52px!important;}' +
      'html body #Details-menu-drawer-container[open] > .menu-drawer > .zoalin-menu-drawer-head .zoalin-menu-drawer-logo,' +
      'html body #Details-menu-drawer-container.menu-open > .menu-drawer > .zoalin-menu-drawer-head .zoalin-menu-drawer-logo,' +
      'html body.zoalin-menu-drawer-open #Details-menu-drawer-container > .menu-drawer > .zoalin-menu-drawer-head .zoalin-menu-drawer-logo,' +
      'html body #Details-menu-drawer-container[open] > .menu-drawer > .zoalin-menu-drawer-head .zoalin-menu-drawer-actions,' +
      'html body #Details-menu-drawer-container.menu-open > .menu-drawer > .zoalin-menu-drawer-head .zoalin-menu-drawer-actions,' +
      'html body.zoalin-menu-drawer-open #Details-menu-drawer-container > .menu-drawer > .zoalin-menu-drawer-head .zoalin-menu-drawer-actions{' +
      'margin-left:2px!important;}' +
      '}';
    if (existing) {
      if (existing.textContent !== cssText) existing.textContent = cssText;
      return;
    }
    var style = document.createElement('style');
    style.id = id;
    style.textContent = cssText;
    document.head.appendChild(style);
  }

  function deliveryDaysForCountry(code) {
    var countryCode = String(code || '').toUpperCase();
    var transitMin = 10;
    var transitMax = 18;
    if (deliveryAsia.indexOf(countryCode) !== -1) {
      transitMin = 5;
      transitMax = 10;
    } else if (deliveryMiddleEastUs.indexOf(countryCode) !== -1) {
      transitMin = 7;
      transitMax = 12;
    } else if (deliveryStandard.indexOf(countryCode) !== -1) {
      transitMin = 7;
      transitMax = 15;
    }
    return { min: transitMin + 1, max: transitMax + 3 };
  }

  function addBusinessDays(input, days) {
    var date = new Date(input);
    var added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      var weekday = date.getDay();
      if (weekday !== 0 && weekday !== 6) added += 1;
    }
    return date;
  }

  function formatDeliveryDate(date) {
    var locale = (window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'en';
    try {
      return new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' }).format(date);
    } catch (error) {
      return new Intl.DateTimeFormat('en', { month: 'short', day: 'numeric' }).format(date);
    }
  }

  function updateDeliveryCountrySelect(select) {
    if (!select) return false;
    select.removeAttribute('onchange');
    select.onchange = null;
    var option = select.options && select.options[select.selectedIndex];
    var root = select.closest && (select.closest('.zoalin-delivery') || select.closest('.product__info-container'));
    var minDays = Number(option && option.getAttribute('data-min-days'));
    var maxDays = Number(option && option.getAttribute('data-max-days'));
    if (!Number.isFinite(minDays) || !Number.isFinite(maxDays)) {
      var days = deliveryDaysForCountry(select.value);
      minDays = days.min;
      maxDays = days.max;
    }
    if (root && root.classList && root.classList.contains('zoalin-delivery')) {
      root.setAttribute('data-min-days', String(minDays));
      root.setAttribute('data-max-days', String(maxDays));
      root.setAttribute('data-country', (option && (option.getAttribute('data-country-name') || option.textContent || '')).trim());
    }
    var output = root && root.querySelector && root.querySelector('[data-delivery-window]');
    if (!output) output = document.querySelector('[data-delivery-window]');
    if (output) {
      var today = new Date();
      output.textContent = formatDeliveryDate(addBusinessDays(today, minDays)) + '-' + formatDeliveryDate(addBusinessDays(today, maxDays));
    }
    return true;
  }

  function guardDeliveryCountrySelects() {
    document.querySelectorAll(deliverySelectSelector).forEach(function (select) {
      if (select.getAttribute('data-zoalin-delivery-guard-bound') === marker) return;
      select.setAttribute('data-zoalin-delivery-guard-bound', marker);
      select.removeAttribute('onchange');
      select.onchange = null;
      var form = select.closest && select.closest('form');
      if (form) form.setAttribute('data-zoalin-delivery-form-guard', marker);
      select.addEventListener('change', function (event) {
        event.preventDefault();
        event.stopPropagation();
        updateDeliveryCountrySelect(select);
        return false;
      }, true);
    });
  }

  function makeRow(root) {
    var list = root && root.querySelector('[data-localization-list], .zoalin-localization__list');
    if (!list) return null;
    var row = root.querySelector('[data-country-code="US"]');
    if (!row) {
      row = document.createElement('button');
      row.type = 'button';
      row.className = 'zoalin-localization__country zoalin-localization__country--manual zoalin-localization__country--united-states zoalin-localization__country--single-currency';
      row.setAttribute('role', 'option');
      row.setAttribute('aria-selected', 'false');
      row.setAttribute('data-country-code', 'US');
      row.setAttribute('data-country-manual', 'true');
      row.setAttribute('data-country-search', 'united states us usa usd');
      row.innerHTML = '<span class="zoalin-localization__country-flag zoalin-localization__country-flag--us" aria-hidden="true"></span><span class="zoalin-localization__country-name">United States</span><span class="zoalin-localization__check" aria-hidden="true"><svg viewBox="0 0 18 18" fill="none"><path d="m3.75 9.25 3.15 3.15 7.35-7.35" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
      list.insertBefore(row, list.querySelector('[data-localization-empty], .zoalin-localization__empty') || null);
    }
    return row;
  }

  function show(row) {
    if (!row) return;
    row.hidden = false;
    row.disabled = false;
    ['hidden', 'disabled', 'aria-hidden', 'aria-disabled', 'data-zoalin-country-unavailable', 'data-zoalin-unavailable-country-bound'].forEach(function (name) {
      row.removeAttribute(name);
    });
    css(row, { display: 'grid', 'grid-template-columns': '24px minmax(0, 1fr) 20px', 'align-items': 'center', gap: '12px', visibility: 'visible', opacity: '1', width: '100%', height: 'auto', 'min-height': '52px', margin: '0', padding: '0 8px', border: '0', 'border-bottom': '1px solid #ece7df', 'box-sizing': 'border-box', overflow: 'visible', 'pointer-events': 'auto', appearance: 'none', '-webkit-appearance': 'none', background: row.classList.contains('is-current') || row.getAttribute('aria-selected') === 'true' ? '#f7f4ef' : 'transparent' });
    css(row.querySelector('.zoalin-localization__country-flag'), { display: 'block', width: '24px', 'min-width': '24px', height: '16px', 'min-height': '16px', 'border-radius': '2px', border: '1px solid rgba(17,17,17,.14)', background: '#fff', 'background-image': flag, 'background-size': 'cover', 'background-position': '50% 50%', 'background-repeat': 'no-repeat', 'box-sizing': 'border-box' });
    css(row.querySelector('.zoalin-localization__country-name'), { display: 'block', visibility: 'visible', opacity: '1', color: '#111', 'font-size': '16px', 'font-weight': '500', 'line-height': '1.25' });
  }

  function restore() {
    roots().forEach(function (root) {
      show(makeRow(root));
    });
    document.documentElement.setAttribute('data-zoalin-us-row-global-restore', marker);
  }

  function select(row) {
    var root = row && row.closest('.zoalin-localization, [data-zoalin-localization]');
    if (!root) return;
    restore();
    root.querySelectorAll('[data-country-code]').forEach(function (country) {
      country.classList.remove('is-current');
      country.setAttribute('aria-selected', 'false');
    });
    row.classList.add('is-current');
    row.setAttribute('aria-selected', 'true');
    var input = root.querySelector('[data-localization-country-input], input[name="country_code"]');
    if (input) input.value = 'US';
    var trigger = root.querySelector('[data-localization-open], .zoalin-localization__trigger');
    var label = trigger && trigger.querySelector('span:not(.zoalin-localization__flag):not(.zoalin-localization__caret)');
    if (label) label.textContent = 'United States ' + String.fromCharCode(183) + ' USD';
    var triggerFlag = trigger && trigger.querySelector('.zoalin-localization__flag');
    if (triggerFlag) {
      triggerFlag.removeAttribute('style');
      triggerFlag.classList.add('zoalin-localization__flag--us');
      css(triggerFlag, { background: '#fff', 'background-image': flag, 'background-size': 'cover', 'background-position': '50% 50%', 'background-repeat': 'no-repeat' });
    }
    try {
      window.localStorage.setItem('zoalinManualCountryCode', 'US');
    } catch (error) {}
    var dialog = row.closest('dialog');
    if (dialog && typeof dialog.close === 'function') dialog.close();
  }

  function bindSearch() {
    document.querySelectorAll('[data-localization-search], .zoalin-localization__search input').forEach(function (input) {
      if (input.getAttribute('data-zoalin-us-search-bound') === marker) return;
      input.setAttribute('data-zoalin-us-search-bound', marker);
      input.addEventListener('input', function () {
        restore();
        var root = input.closest('.zoalin-localization, [data-zoalin-localization]');
        var row = root && root.querySelector('[data-country-code="US"]');
        if (!row) return;
        var term = (input.value || '').trim().toLowerCase();
        var matches = !term || (row.getAttribute('data-country-search') || '').indexOf(term) !== -1;
        row.hidden = !matches;
        css(row, { display: matches ? 'grid' : 'none' });
      });
    });
  }

  function schedule() {
    injectDrawerCloseRightStyle();
    rewriteContactLinks();
    restore();
    bindSearch();
    guardDeliveryCountrySelects();
    [40, 120, 280, 700, 1400, 2600, 4200].forEach(function (delay) {
      setTimeout(function () {
        injectDrawerCloseRightStyle();
        rewriteContactLinks();
        restore();
        bindSearch();
        guardDeliveryCountrySelects();
      }, delay);
    });
  }

  document.addEventListener('change', function (event) {
    var select = event.target && event.target.closest && event.target.closest(deliverySelectSelector);
    if (!select) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    updateDeliveryCountrySelect(select);
    return false;
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    var select = form && form.querySelector && form.querySelector(deliverySelectSelector);
    if (!select && form && form.getAttribute && form.getAttribute('data-zoalin-delivery-form-guard') === marker) {
      select = form.querySelector('select[name="country_code"]');
    }
    if (!select) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    updateDeliveryCountrySelect(select);
    return false;
  }, true);

  document.addEventListener('click', function (event) {
    var row = event.target && event.target.closest && event.target.closest('.zoalin-localization [data-country-code="US"], [data-zoalin-localization] [data-country-code="US"]');
    var contactLink = event.target && event.target.closest && event.target.closest('a[href="/pages/contact"], a[href^="/pages/contact?"]');
    if (contactLink) {
      event.preventDefault();
      window.location.href = '/pages/contact-us';
      return false;
    }
    if (row) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      select(row);
      return false;
    }
    if (event.target && event.target.closest && event.target.closest('[data-localization-open], .zoalin-localization__trigger, .zoalin-localization__dialog')) {
      schedule();
    }
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
  window.addEventListener('load', schedule);
  window.addEventListener('pageshow', schedule);
})();
